var storefrontAppDependencies = [
    'ui.bootstrap',
    'ngStorage',
    'pascalprecht.translate',
    'ngSanitize'
]

angular.module('storefrontApp', storefrontAppDependencies)
    .factory('httpErrorInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {
        var httpErrorInterceptor = {};

        httpErrorInterceptor.responseError = function (rejection) {
            if (rejection.data && rejection.data.message) {
                if (rejection.status === 400) {
                    $rootScope.$broadcast('storefrontError', {
                        type: 'error',
                        message: rejection.data.message
                    });
                } else {
                    $rootScope.$broadcast('storefrontError', {
                        type: 'exception',
                        title: [rejection.config.method, rejection.config.url, rejection.status, rejection.statusText, rejection.data.message].join(' '),
                        message: rejection.data.stackTrace
                    });
                }
            }
            return $q.reject(rejection);
        };
        httpErrorInterceptor.requestError = function (rejection) {
            if (rejection.data && rejection.data.message) {
                $rootScope.$broadcast('storefrontError', {
                    type: 'exception',
                    title: [rejection.config.method, rejection.config.url, rejection.status, rejection.statusText, rejection.data.message].join(' '),
                    message: rejection.data.stackTrace
                });
            }
            return $q.reject(rejection);
        };

        return httpErrorInterceptor;
    }])

    .config(['$httpProvider', '$translateProvider', function ($httpProvider, $translateProvider) {
        $httpProvider.interceptors.push('httpErrorInterceptor');

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.useUrlLoader(BASE_URL + 'themes/localization.json');
        $translateProvider.preferredLanguage('en');

    }])
    
    .factory('orderHelper', function () {
        var retVal = {
            getNewPayment: function (order, paymentMethods, newPaymentTemplate) {
                var retVal;
                var paidPayments = _.filter(order.inPayments, function (x) {
                    return x.status === 'Paid' || x.status === 'Authorized';
                });
                var paidAmount = _.reduce(paidPayments, function (memo, num) { return memo + num.sum.amount; }, 0);
                var amountToPay = order.total.amount - paidAmount;
    
                var pendingPayments = _.filter(order.inPayments, function (x) {
                    return !x.isCancelled &&
                            (x.status === 'New' || x.status === 'Pending') &&
                            x.sum.amount > 0; // && x.sum.amount === amountToPay;
                });
                var pendingPayment = _.last(_.sortBy(pendingPayments, 'createdDate'));
                if (pendingPayment && (!paymentMethods || _.findWhere(paymentMethods, { code: pendingPayment.gatewayCode }))) {
                    retVal = pendingPayment;
                } else {
                    newPaymentTemplate = newPaymentTemplate || { sum: {} };
                    newPaymentTemplate.sum.amount = amountToPay;
                    retVal = newPaymentTemplate;
                }
    
                return retVal;
            }
        };
    
        return retVal;
    })

.filter('orderToSummarizedStatusLabel', ['orderHelper', function (orderHelper) {
    return function (order) {
        var retVal = order.status || 'New';

        var found = _.findWhere(orderHelper.statusLabels, { status: retVal.toLowerCase() });
        if (found) {
            retVal = found.label;
        }

        return retVal;
    };
}]);
